var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7ZM10.5262 4.34875C10.4637 4.28647 10.3893 4.23743 10.3074 4.20456C10.2256 4.1717 10.1379 4.15569 10.0497 4.15749C9.96144 4.15928 9.87449 4.17885 9.79401 4.21502C9.71352 4.25119 9.64116 4.30322 9.58125 4.368L6.54238 8.23987L4.711 6.40763C4.5866 6.29171 4.42206 6.2286 4.25204 6.2316C4.08203 6.2346 3.91982 6.30347 3.79958 6.42371C3.67934 6.54394 3.61047 6.70615 3.60747 6.87617C3.60447 7.04618 3.66758 7.21072 3.7835 7.33513L6.09875 9.65125C6.16112 9.71351 6.23539 9.76257 6.31714 9.7955C6.39888 9.82843 6.48642 9.84456 6.57453 9.84293C6.66264 9.84129 6.74952 9.82193 6.82998 9.78599C6.91045 9.75005 6.98285 9.69828 7.04287 9.63375L10.5359 5.2675C10.655 5.14369 10.7207 4.97812 10.7191 4.80634C10.7175 4.63456 10.6485 4.47027 10.5271 4.34875H10.5262Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green__tick.ae458ebf3f02dccf22e6cc7707f8634d.svg";
export { ForwardRef as ReactComponent };